import React, { useEffect, useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import logo from '../Images/logo.png'
import { aboutLinks, bentoniteMinerals, industrialMinerals } from "../Data";
import { FaYoutube, FaFacebookF, FaLinkedinIn, FaEnvelope, FaPhoneAlt } from "react-icons/fa";

const MainHeader=()=>{
      const [scrolled, setScrolled] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const navigate = useNavigate();

 useEffect(() => {
  if (menuOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
}, [menuOpen]);

  // Inside your Hero component
useEffect(() => {
  const handleScroll = () => {
    if (!isMobile) {
      setScrolled(window.scrollY > 100);
    }
  };

  window.addEventListener("scroll", handleScroll, { passive: true });
  return () => window.removeEventListener("scroll", handleScroll);
}, [isMobile]);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 992);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const navContainer = {
    hidden: { opacity: 0, y: -30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
        staggerChildren: 0.08
      }
    }
  };

  const navItem = {
    hidden: { opacity: 0, y: -10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  };
    return(
        <>
        <motion.header
        variants={navContainer}
        initial="hidden"
        animate="visible"
        className={`navbar-main ${scrolled ? "scrolled" : ""} ${
          hovered ? "hovered" : ""
        }`}
        onMouseEnter={() => !isMobile && setHovered(true)}
onMouseLeave={() => !isMobile && setHovered(false)}
      >
        {/* LOGO */}
        <motion.div
          className="logo-row"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
       <Link to='/'> <img src={logo} alt="Iris Impulse India Pvt. Ltd. Logo" className="logo" /> </Link>

  {/* HAMBURGER */}
  <div
    className={`hamburger ${menuOpen ? "active" : ""}`}
    onClick={() => setMenuOpen(!menuOpen)}
  >
    <span></span>
    <span></span>
    <span></span>
  </div>
        </motion.div>

        {/* NAV LINKS */}
        <nav className="nav-row-main">
          <ul>
            <a href="/"><motion.li variants={navItem}>HOME</motion.li></a>
            <span className="diamond-main"></span>

            {/*<a href="/about-us"><motion.li variants={navItem}>ABOUT US</motion.li></a>*/}
          
            <motion.li variants={navItem} className="dropdown">
              <a href="/about-us"><span className="nav-item">
                ABOUT US
                <span className="chevron"></span>
              </span></a>

              <ul className="dropdown-menu">
                {aboutLinks.map((item, index) => (
                  <Link to={item.url}><li key={index}>{item.title}</li></Link> 
                ))}
              </ul>
            </motion.li>
              <span className="diamond-main"></span>


            {/* BENTONITE */}
            <motion.li variants={navItem} className="dropdown">
             <a href="/bentonite-minerals"><span className="nav-item">
                BENTONITE MINERALS
                <span className="chevron"></span>
              </span></a>

              <ul className="dropdown-menu">
                {bentoniteMinerals.map((item, index) => (
                <Link to={`/bentonite-minerals/${item.url}`}><li key={index}
                                  >{item.title}</li></Link> 
                ))}
              </ul>
            </motion.li>

            <span className="diamond-main"></span>

            {/* INDUSTRIAL */}
            <motion.li variants={navItem} className="dropdown">
              <a href="/industrial-minerals"><span className="nav-item">
                INDUSTRIAL MINERALS
                <span className="chevron"></span>
              </span></a>
 <ul className="dropdown-menu">
               {industrialMinerals.map((item, index) => (
                                 <Link to={`/industrial-minerals/${item.url}`}><li key={index}>{item.title}</li></Link> 
                               ))}
              </ul>
            </motion.li>

            <span className="diamond-main"></span>

            <a href="/blogs"><motion.li variants={navItem}>BLOGS</motion.li></a>
            <span className="diamond-main"></span>

             <a href="/contact-us"><motion.li variants={navItem}>CONTACT US</motion.li></a>
          </ul>
        </nav>
      </motion.header>

      {/* SIDEBAR */}
<div className={`mobile-sidebar ${menuOpen ? "active" : ""}`}>
  
  {/* TOP LOGO */}
  <div className="sidebar-header">
    <img src={logo} alt="Iris Impulse India Pvt. Ltd. Logo" />
  </div>

  <ul>
    <a href="/"><li onClick={() => setMenuOpen(false)}>HOME</li></a>

    <li className="mobile-dropdown">
      <div className="mobile-dropdown-head">
        <span onClick={() => navigate("/about-us")}>
          ABOUT US
        </span>

        <span
          className={`chevron ${openDropdown === "about" ? "open" : ""}`}
          onClick={() =>
            setOpenDropdown(openDropdown === "about" ? null : "about")
          }
        ></span>
      </div>

      <div className={`mobile-submenu ${openDropdown === "about" ? "open" : ""}`}>
        {aboutLinks.map((item, index) => (
          <Link key={index} to={item.url}>
            <div>{item.title}</div>
          </Link>
        ))}
      </div>
    </li>

    {/* BENTONITE */}
    <li className="mobile-dropdown">
      <div className="mobile-dropdown-head">
        <span onClick={() => navigate("/bentonite-minerals")}>
          BENTONITE MINERALS
        </span>

        <span
          className={`chevron ${openDropdown === "bentonite" ? "open" : ""}`}
          onClick={() =>
            setOpenDropdown(openDropdown === "bentonite" ? null : "bentonite")
          }
        ></span>
      </div>

      <div className={`mobile-submenu ${openDropdown === "bentonite" ? "open" : ""}`}>
        {bentoniteMinerals.map((item, index) => (
          <Link key={index} to={`/bentonite-minerals/${item.url}`}>
            <div>{item.title}</div>
          </Link>
        ))}
      </div>
    </li>

    {/* INDUSTRIAL */}
    <li className="mobile-dropdown">
      <div className="mobile-dropdown-head">
        <span onClick={() => navigate("/industrial-minerals")}>
          INDUSTRIAL MINERALS
        </span>

        <span
          className={`chevron ${openDropdown === "industrial" ? "open" : ""}`}
          onClick={() =>
            setOpenDropdown(openDropdown === "industrial" ? null : "industrial")
          }
        ></span>
      </div>

      <div className={`mobile-submenu ${openDropdown === "industrial" ? "open" : ""}`}>
        {industrialMinerals.map((item, index) => (
          <Link key={index} to={`/industrial-minerals/${item.url}`}>
            <div>{item.title}</div>
          </Link>
        ))}
      </div>
    </li>

    <a href="/blogs">
      <li onClick={() => setMenuOpen(false)}>BLOGS</li>
    </a>

    <a href="/contact-us">
      <li onClick={() => setMenuOpen(false)}>CONTACT US</li>
    </a>
  </ul>

  {/* SIDEBAR FOOTER */}
  <div className="mobile-sidebar-footer">

    {/* SOCIAL ICONS */}
    <div className="sidebar-socials">

      <a
        href="https://www.youtube.com/@IrisImpulseIndia"
        target="_blank"
        rel="noreferrer"
      >
        <FaYoutube />
      </a>

      <a
        href="https://www.facebook.com/Irisimpulsebentonite"
        target="_blank"
        rel="noreferrer"
      >
        <FaFacebookF />
      </a>

      <a
        href="https://www.linkedin.com/company/iris-impulse-india-private-limited/"
        target="_blank"
        rel="noreferrer"
      >
        <FaLinkedinIn />
      </a>

    </div>

    {/* EMAIL */}
    <a
      href="mailto:rajan@irisimpulse.com"
      className="sidebar-contact"
    >
      <FaEnvelope />
      <span>rajan@irisimpulse.com</span>
    </a>

    {/* PHONE */}
    <a
      href="tel:+919638482211"
      className="sidebar-contact"
    >
      <FaPhoneAlt />
      <span>+91 96384 82211</span>
    </a>

  </div>

</div>
{/* OVERLAY */}
<div
  className={`sidebar-overlay ${menuOpen ? "active" : ""}`}
  onClick={() => setMenuOpen(false)}
/>
        </>
    )
}
export default MainHeader;